import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as relatorioActions from '../../actions/relatorioActions'
import $ from 'jquery';
import GraficoBarraTotalNaturezaPeriodo from './GraficoBarraTotalNaturezaPeriodo'
import Helpers from '../../util/Helpers'



class TotalNaturezaPeriodoGrafBarra extends React.Component {

        constructor(props, context) {
            super(props, context);
            this.getNatureza = this.getNatureza.bind(this);

            this.state = {
                pesquisando: true
            };
        }

        componentDidMount() {
           
            
            
            if (!$.isEmptyObject(this.props.parametrosPesquisaRelatorio)) {
                
                this.setState({ pesquisando: true });
                this.props.actions.ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(this.props.parametrosPesquisaRelatorio).then(
                    () => {
                        this.setState({ pesquisando: false });
                    }).catch(error => {
                    this.alerta('Erro em relatório', error, 'error', 'tc');
                });
                //console.log(' componentDidMount - ListarTotalMensagemPorClassificacaoPorIdEstruturaPai ', this.props.parametrosPesquisaRelatorio);
            }
        }
        alerta(titulo, mensagem, tipo, posicao) {
            
            // this.props.actionsAlerta.apresentarAlerta({
            //     title: titulo !== null ? titulo : 'Aviso!',
            //     message: mensagem !== null ? mensagem : '',
            //     level: tipo !== null ? tipo : 'error',
            //     position: posicao !== null ? posicao : 'tc',
            //     showMsg: true,
            //     autoDismiss: 25
            // });
        }

        getNatureza(obj) {
            
            if (obj !== null) {
                
                //metodo da dashboard que passará o id para a modal. 
                //console.log('clicou em q gráfico ',this.props.relatorio.dado[obj[0]._index].mClassificacaoOperador);
                this.props.obtemNaturezaSelecionada(obj)


            }

        }
        componentWillReceiveProps(nextProps) {
            
            if (!$.isEmptyObject(nextProps.parametrosPesquisaRelatorio)) {

                if (this.props.parametrosPesquisaRelatorio !== nextProps.parametrosPesquisaRelatorio) {
                    this.setState({ pesquisando: true });
                    this.props.actions.ListarTotalMensagemPorClassificacaoPorIdEstruturaPai(nextProps.parametrosPesquisaRelatorio).then(
                        () => {
                            this.setState({ pesquisando: false });
                        }).catch(error => {
                        this.alerta('Erro em relatório', error, 'error', 'tc');
                    });
                    //console.log('manifestações table ', objPesquisa);
                }
            }
            
            if(!$.isEmptyObject(nextProps.relatorio)){
                if (this.props.relatorio !== nextProps.relatorio) {
                    var valorTotal = 0
                    for(var i = 0, len = nextProps.relatorio.dado.length; i < len; i++) {
                        valorTotal += nextProps.relatorio.dado[i].mTotalMensagens; 
                    }
                    this.props.relatorioNatureza(valorTotal);          
                }
            }
        }


    render() {
        console.log('Grafico NATUREZA this.props.relatorio - ', this.props.relatorio)
       
        if ($.isEmptyObject(this.props.relatorio) ) {
            return <div className='row loading'> <div className="col-lg-12 col-md-12 col-xs-12"><div className="dots-loader">Pesquisando...</div></div></div>
        }

      if(this.props.relatorio.dado===null){
          return <div className='col-centered'><h4>Não existem manifestações neste período.</h4></div>
      }

     
     //console.log('tipicas de ouvidoria: ', this.props.relatorio);
     var classificacoes = [];
     if (this.props.tipicasOuvidoria) {
         var count;
         for (count = 0; count < (this.props.relatorio.dado.length); count++) {
             
             if (this.props.relatorio.dado[count].mClassificacaoOperador.mTipicaOuvidoria) {
                 classificacoes.push({
                     id:this.props.relatorio.dado[count].mClassificacaoOperador.mIdClassificacao,
                     descricao: this.props.relatorio.dado[count].mClassificacaoOperador.mDescricao !== null ? this.props.relatorio.dado[count].mClassificacaoOperador.mDescricao : 'Sem classificar',
                     total: this.props.relatorio.dado[count].mTotalMensagens
                 });
             }
         }
     } else {
         classificacoes = this.props.relatorio.dado.map(item => {
             return {
                 id:item.mClassificacaoOperador.mIdClassificacao,
                 descricao: item.mClassificacaoOperador.mDescricao !== null ? item.mClassificacaoOperador.mDescricao : 'Sem classificar',
                 total: item.mTotalMensagens,
                 totalMensagensNaoResponsabilidadeSebrae: item.mTotalMensagensNaoResponsabilidadeSebrae
             }
         });
     }

     return (
        <div>
            <GraficoBarraTotalNaturezaPeriodo classificacoes={classificacoes} obtemNaturezaSelecionada={this.getNatureza}/>
        </div>
        
    );
  }
}
TotalNaturezaPeriodoGrafBarra.protoType = {
    actions: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    
    return {
            relatorio: state.relatorioClassificacao
    };
}

function mapDispatchToProps(dispatch){
    return {
        actions: bindActionCreators(relatorioActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TotalNaturezaPeriodoGrafBarra);


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/Natureza/TotalNaturezaPeriodoGrafBarra.js
 **/